/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { PiEyeSlashLight, PiEyeThin } from "react-icons/pi";
import { MdOutlineCancel } from "react-icons/md";
import Modal from "../Modal/Modal";
import Logo from "../../Images/Logo.svg";
import { adminLoginAction } from "../../Redux/actions/auth";
import { RotatingLines } from "react-loader-spinner";
const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState("password");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isModalOpen = useSelector((state) => state.modal.isModalOpen);
  const error = useSelector((state) => state.auth.error);
  const admin = useSelector((state) => state.auth.admin);
  const [loading, setLoading] = useState(false);

  const handleAdminLogin = async () => {
    setLoading(true); 
  
    const loginSuccessful = await dispatch(adminLoginAction(email, password));
  
    if (loginSuccessful) {
      navigate("/admin-dashboard");
    } else {
      console.error("Admin login failed, not navigating to the dashboard.");
    }
  
    setLoading(false);
  };
  

  return (
    <>
      <div className="flex md:justify-between justify-center md:ml-20 ">
        <Link to="/">
          <div className="xl:w-[300px] cursor-pointer">
            <img src={Logo} alt="" className="w-[150px]" />
          </div>
        </Link>

        <Link to="/">
          <div className="absolute top-4 right-8 cursor-pointer">
            <MdOutlineCancel className="text-2xl hidden md:block" />
          </div>
        </Link>
      </div>
      <div className="flex justify-center">
        {isModalOpen && <Modal />}
        <div className="relative flex w-full max-w-md flex-col space-y-5 rounded-lg mt-8 mb-14 border bg-white px-5 py-6 shadow-xl sm:mx-auto">
          <div className="-z-10 absolute top-4 left-1/2 h-full w-5/6 -translate-x-1/2 rounded-lg bg-gray-600 sm:-right-10 sm:top-auto sm:left-auto sm:w-full sm:translate-x-0"></div>
          <div className="mx-auto mb-2 space-y-3">
            <h1 className="text-center text-3xl font-bold text-gray-700">
              Welcome Admin
            </h1>
            <p className="text-gray-500">Login to access your admin account</p>
          </div>

          {error && <p className="text-red-500 text-center">{error}</p>}

          <div>
            <div className="relative mt-2 w-full">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border-1 peer block w-full appearance-none rounded-lg border border-gray-300 bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                placeholder=" "
              />
              <label
                htmlFor="email"
                className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300"
              >
                Enter Your Email
              </label>
            </div>
          </div>

          <div>
            <div className="relative mt-2 w-full">
              <input
                type={showPassword}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                id="password"
                className="border-1 peer block w-full appearance-none rounded-lg border border-gray-300 bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                placeholder=" "
              />
              <label
                htmlFor="password"
                className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300"
              >
                Enter Your Password
              </label>
              {showPassword === "password" ? (
                <div
                  onClick={() => setShowPassword("text")}
                  className="absolute top-4 right-2 cursor-pointer"
                >
                  <PiEyeSlashLight />
                </div>
              ) : (
                <div
                  onClick={() => setShowPassword("password")}
                  className="absolute top-4 right-2 cursor-pointer"
                >
                  <PiEyeThin />
                </div>
              )}
            </div>
          </div>
          <div className="flex w-full items-center">
            <button
              onClick={handleAdminLogin}
              className="shrink-0 inline-block w-36 rounded-lg flex justify-center bg-gray-700 py-3 font-bold text-white"
              disabled={loading}   >
              {loading ? (
                <RotatingLines
                  strokeColor="#fff"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="20"
                  visible={true}
                />
              ) : (
                "Login"
              )}
            </button>
            <a
              className="w-full text-center text-sm font-medium text-gray-600 hover:underline"
              href="/forgot-password"
            >
              Forgot your password?
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;



